/* EL PASAJERO — interacciones (vanilla, sin librerías) */
(function () {
  'use strict';

  /* Este archivo lo incluye cada sección ep-* con su propia etiqueta <script>. El navegador
     ejecuta cada etiqueta por separado, así que sin este cerrojo los manejadores se registraban
     varias veces y UN clic en "Añadir al carrito" metía 2-5 packs (detectado el 7/9/2026). */
  if (window.__epScriptsCargado) return;
  window.__epScriptsCargado = true;

  /* Reveals al hacer scroll (un solo observer compartido) */
  function initReveals() {
    var els = document.querySelectorAll('.ep-reveal');
    if (!els.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('ep-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('ep-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Cuenta atrás (una o varias por página) */
  function initCountdowns() {
    var zonas = document.querySelectorAll('[data-ep-countdown]');
    if (!zonas.length) return;
    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      var ahora = Date.now();
      zonas.forEach(function (z) {
        var destino = new Date(z.getAttribute('data-ep-countdown')).getTime();
        var diff = Math.max(0, destino - ahora);
        var d = Math.floor(diff / 86400000);
        var h = Math.floor(diff / 3600000) % 24;
        var m = Math.floor(diff / 60000) % 60;
        var s = Math.floor(diff / 1000) % 60;
        var setN = function (sel, val) {
          var el = z.querySelector(sel);
          if (el && el.textContent !== val) el.textContent = val;
        };
        setN('[data-ep-d]', String(d));
        setN('[data-ep-h]', pad(h));
        setN('[data-ep-m]', pad(m));
        setN('[data-ep-s]', pad(s));
        var corto = z.querySelector('[data-ep-corto]');
        if (corto) corto.textContent = d + ' días';
      });
    }
    tick();
    setInterval(tick, 1000);
  }

  /* Galería de producto: cambiar imagen principal */
  function initGaleria() {
    var gal = document.querySelector('[data-ep-galeria]');
    if (!gal) return;
    var principal = gal.querySelector('[data-ep-principal]');
    gal.querySelectorAll('.ep-galeria__thumb').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.getAttribute('data-ep-src');
        if (!src || !principal) return;
        principal.src = src;
        gal.querySelectorAll('.ep-galeria__thumb').forEach(function (b) { b.classList.remove('ep-activa'); });
        btn.classList.add('ep-activa');
      });
    });
  }

  /* Selector de variantes (personajes) */
  function initVariantes() {
    var zona = document.querySelector('[data-ep-producto]');
    if (!zona) return;
    var dataEl = document.querySelector('[data-ep-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var inputId = zona.querySelector('input[name="id"]');
    var botones = zona.querySelectorAll('.ep-variante');
    var precioEl = zona.querySelector('[data-ep-precio]');
    var btnComprar = zona.querySelector('[data-ep-comprar]');
    var nombreEl = zona.querySelector('[data-ep-variante-nombre]');
    var principal = document.querySelector('[data-ep-principal]');
    var barraPrecio = document.querySelector('[data-ep-barra-precio]');

    function formatearEUR(centimos) {
      if (typeof centimos !== 'number' || isNaN(centimos)) return null;
      return (centimos / 100).toFixed(2).replace('.', ',') + ' €';
    }

    botones.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-ep-id');
        var v = null;
        for (var i = 0; i < variantes.length; i++) {
          if (String(variantes[i].id) === String(id)) { v = variantes[i]; break; }
        }
        if (!v || !inputId) return;
        inputId.value = v.id;
        botones.forEach(function (b) { b.classList.remove('ep-activa'); });
        btn.classList.add('ep-activa');
        if (nombreEl) nombreEl.textContent = v.title;
        var precioTxt = formatearEUR(v.price);
        if (precioEl && precioTxt) precioEl.textContent = precioTxt;
        if (barraPrecio && precioTxt) barraPrecio.textContent = precioTxt;
        if (v.featured_image && v.featured_image.src && principal) {
          principal.src = v.featured_image.src;
          document.querySelectorAll('.ep-galeria__thumb').forEach(function (b) { b.classList.remove('ep-activa'); });
        }
        if (btnComprar) {
          if (v.available) {
            btnComprar.removeAttribute('disabled');
            btnComprar.textContent = btnComprar.getAttribute('data-ep-texto') || 'Añadir al carrito';
          } else {
            btnComprar.setAttribute('disabled', 'disabled');
            btnComprar.textContent = btnComprar.getAttribute('data-ep-texto-agotado') || 'Agotado';
          }
        }
      });
    });
  }

  /* Barra de compra fija en móvil (aparece al pasar el formulario) */
  function initBarraMovil() {
    var barra = document.querySelector('.ep-barra-movil');
    var ancla = document.querySelector('[data-ep-compra-ancla]');
    if (!barra || !ancla) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        barra.classList.toggle('ep-visible-barra', !e.isIntersecting && e.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    io.observe(ancla);
    var btn = barra.querySelector('[data-ep-barra-btn]');
    if (btn) {
      btn.addEventListener('click', function () {
        ancla.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  }

  /* Compra sin salir de la pagina: confirmacion animada de marca */
  function initCompraAjax() {
    var zona = document.querySelector('[data-ep-producto]');
    if (!zona || !window.fetch) return;
    var form = zona.querySelector('form[action*="/cart/add"]');
    var btn = zona.querySelector('[data-ep-comprar]');
    if (!form) return;

    function euros(centimos) {
      if (typeof centimos !== 'number' || isNaN(centimos)) return '';
      return (centimos / 100).toFixed(2).replace('.', ',') + ' €';
    }

    function actualizarBadge(n) {
      var carritos = document.querySelectorAll('.vr-carrito');
      carritos.forEach(function (c) {
        var badge = c.querySelector('.vr-carrito__n');
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'vr-carrito__n';
          c.appendChild(badge);
        }
        badge.textContent = n;
      });
    }

    var overlay = null;
    function construirOverlay() {
      overlay = document.createElement('div');
      overlay.className = 'ep-added';
      overlay.hidden = true;
      overlay.innerHTML =
        '<div class="ep-added__velo" data-ep-cerrar></div>' +
        '<div class="ep-added__card" role="dialog" aria-modal="true" aria-label="Añadido al carrito">' +
        '  <div class="ep-added__check" aria-hidden="true">✓</div>' +
        '  <div class="ep-added__img"><img alt="" width="112" height="112"></div>' +
        '  <p class="ep-added__titulo"><span data-ep-nombre></span> ya está en tu coche</p>' +
        '  <p class="ep-added__sub" data-ep-sub></p>' +
        '  <div class="ep-added__hint" data-ep-hint></div>' +
        '  <div class="ep-added__acciones">' +
        '    <a class="ep-btn" href="/cart">Ver mi carrito</a>' +
        '    <button class="ep-btn ep-btn--ghost" type="button" data-ep-cerrar>Seguir mirando</button>' +
        '  </div>' +
        '</div>';
      document.body.appendChild(overlay);
      overlay.addEventListener('click', function (e) {
        if (e.target.hasAttribute && e.target.hasAttribute('data-ep-cerrar')) cerrarOverlay();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') cerrarOverlay();
      });
    }

    function cerrarOverlay() {
      if (!overlay) return;
      overlay.classList.remove('ep-added--visible');
      window.setTimeout(function () { overlay.hidden = true; }, 320);
    }

    function mostrarConfirmacion(item, cart, esPack) {
      if (!overlay) construirOverlay();
      var img = overlay.querySelector('.ep-added__img img');
      if (item.image) { img.src = item.image; img.hidden = false; } else { img.hidden = true; }
      overlay.querySelector('[data-ep-nombre]').textContent = item.variant_title || item.product_title || 'Tu pasajero';
      if (esPack) {
        overlay.querySelector('[data-ep-sub]').textContent = 'Coche completo: 2 packs, 4 fundas · ' + euros(Math.round(item.price * 2 * 0.8)) + ' con el −20% ya restado';
      } else {
        overlay.querySelector('[data-ep-sub]').textContent = 'Pack de 2 unidades · ' + euros(item.price);
      }
      var hint = overlay.querySelector('[data-ep-hint]');
      if (cart && cart.item_count >= 2) {
        hint.innerHTML = '🎃 Ya tienes 2 packs: el <strong>−20%</strong> se aplica solo al pagar. Coche completo, precio de risa.';
      } else {
        hint.innerHTML = '🎃 Añade un segundo personaje (los 4 asientos) y el <strong>−20%</strong> se aplica automáticamente en todo el pedido.';
      }
      overlay.hidden = false;
      // forzar reflow para que la transicion se dispare
      void overlay.offsetWidth;
      overlay.classList.add('ep-added--visible');
      if (cart) actualizarBadge(cart.item_count);
    }

    /* Botón "Coche completo": mete 2 packs del personaje elegido de una vez */
    var btnPack = zona.querySelector('[data-ep-pack2]');
    if (btnPack) {
      btnPack.addEventListener('click', function () {
        var inputId = form.querySelector('input[name="id"]');
        if (!inputId || btnPack.hasAttribute('disabled')) return;
        var textoPack = btnPack.innerHTML;
        btnPack.setAttribute('disabled', 'disabled');
        btnPack.querySelector('.ep-btn--pack__t').textContent = 'Subiendo a tu coche…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: inputId.value, quantity: 2 }] })
        })
          .then(function (r) { if (!r.ok) { throw new Error('add'); } return r.json(); })
          .then(function (res) {
            var item = (res.items && res.items[0]) || res;
            return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
              mostrarConfirmacion(item, cart, true);
            });
          })
          .catch(function () { window.location.href = '/cart/add?id=' + inputId.value + '&quantity=2'; })
          .then(function () { btnPack.removeAttribute('disabled'); btnPack.innerHTML = textoPack; });
      });
    }

    var enviando = false;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (enviando) return;
      enviando = true;
      var textoOriginal = btn ? btn.textContent : '';
      if (btn) { btn.setAttribute('disabled', 'disabled'); btn.textContent = 'Subiendo a tu coche…'; }
      var fd = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) { throw new Error('add'); } return r.json(); })
        .then(function (item) {
          return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            mostrarConfirmacion(item, cart);
          });
        })
        .catch(function () {
          // plan B: compra clasica con recarga de pagina
          // (form.submit() programatico no vuelve a disparar este handler)
          form.submit();
        })
        .then(function () {
          enviando = false;
          if (btn) { btn.removeAttribute('disabled'); btn.textContent = textoOriginal; }
        });
    });
  }

  /* Carrito: banner llamativo con el ahorro del descuento automático (−20% con 2 packs) */
  function initAhorroCarrito() {
    if (!window.fetch) return;
    if (!document.querySelector('.cart-summary__inner')) return;

    if (!document.getElementById('ep-ahorro-css')) {
      var st = document.createElement('style');
      st.id = 'ep-ahorro-css';
      st.textContent =
        '.ep-ahorro{width:100%;box-sizing:border-box;background:linear-gradient(135deg,#2A1508,#1C171F);border:1px solid rgba(255,122,46,.55);border-radius:14px;padding:14px 16px;animation:epAhorroPop .45s cubic-bezier(.2,.9,.3,1.4)}' +
        '.ep-ahorro__kicker{display:block;color:#FF7A2E;font-weight:800;letter-spacing:.08em;text-transform:uppercase;font-size:12px;margin:0 0 8px}' +
        '.ep-ahorro__linea{display:flex;align-items:baseline;gap:10px;flex-wrap:wrap}' +
        '.ep-ahorro__antes{color:rgba(237,230,220,.55);text-decoration:line-through;font-size:16px}' +
        '.ep-ahorro__ahora{color:#EDE6DC;font-weight:900;font-size:26px;line-height:1}' +
        '.ep-ahorro__pill{display:inline-block;background:#E8641B;color:#fff;font-weight:800;border-radius:999px;padding:4px 12px;font-size:13px;margin-top:10px;animation:epAhorroPulse 1.6s ease-in-out infinite}' +
        '.ep-ahorro__nota{color:rgba(237,230,220,.85);font-size:14px;margin:6px 0 0;line-height:1.45}' +
        '.ep-ahorro__nota strong{color:#FF7A2E}' +
        '@keyframes epAhorroPulse{0%,100%{transform:scale(1);box-shadow:0 0 0 0 rgba(232,100,27,.45)}50%{transform:scale(1.04);box-shadow:0 0 0 9px rgba(232,100,27,0)}}' +
        '@keyframes epAhorroPop{from{opacity:0;transform:translateY(6px) scale(.97)}to{opacity:1;transform:none}}';
      document.head.appendChild(st);
    }

    function euros(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }

    function pintar(cart) {
      var zonas = document.querySelectorAll('.cart-summary__inner');
      if (!zonas.length) return;
      var ahorro = cart.original_total_price - cart.total_price;
      var firma = cart.item_count + ':' + cart.total_price + ':' + ahorro;
      zonas.forEach(function (zona) {
        var b = zona.querySelector('.ep-ahorro');
        if (b && b.getAttribute('data-ep-firma') === firma) return;
        if (!cart.item_count) { if (b) b.remove(); return; }
        if (!b) {
          b = document.createElement('div');
          b.className = 'ep-ahorro';
          zona.insertBefore(b, zona.firstChild);
        }
        b.setAttribute('data-ep-firma', firma);
        if (ahorro > 0) {
          var pct = Math.round((ahorro / cart.original_total_price) * 100);
          b.innerHTML =
            '<span class="ep-ahorro__kicker">🎃 Pack coche completo activado</span>' +
            '<div class="ep-ahorro__linea"><s class="ep-ahorro__antes">' + euros(cart.original_total_price) + '</s>' +
            '<span class="ep-ahorro__ahora">' + euros(cart.total_price) + '</span></div>' +
            '<span class="ep-ahorro__pill">Estás ahorrando ' + euros(ahorro) + ' (−' + pct + '%)</span>';
        } else {
          var unit = (cart.items && cart.items[0]) ? cart.items[0].price : 2295;
          var dos = Math.round(unit * 2 * 0.8);
          b.innerHTML =
            '<span class="ep-ahorro__kicker">🎃 A un pack del coche completo</span>' +
            '<p class="ep-ahorro__nota">Añade un 2º personaje y el <strong>−20%</strong> salta solo: los 4 asientos por <strong>' + euros(dos) + '</strong> en vez de ' + euros(unit * 2) + '.</p>';
        }
      });
    }

    var pidiendo = false;
    function refrescar() {
      if (pidiendo || !document.querySelector('.cart-summary__inner')) return;
      pidiendo = true;
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(pintar)
        .catch(function () {})
        .then(function () { pidiendo = false; });
    }

    refrescar();
    /* El tema re-renderiza el resumen al cambiar cantidades: re-pintar con datos frescos.
       pintar() no toca el DOM si nada cambió, así que no hay bucle. */
    var espera = null;
    new MutationObserver(function () {
      if (espera) return;
      espera = window.setTimeout(function () { espera = null; refrescar(); }, 300);
    }).observe(document.body, { childList: true, subtree: true });
  }

  function initTodo() {
    initReveals();
    initCountdowns();
    initGaleria();
    initVariantes();
    initBarraMovil();
    initCompraAjax();
    initAhorroCarrito();
  }

  /* Si el script llega tarde (secciones que lo cargan tras DOMContentLoaded),
     inicializar igualmente: sin esto, ningun clic funciona. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTodo);
  } else {
    initTodo();
  }
})();